  <!-- Breadcrumb -->
<div class="content-breadcrumb div-breadcrumb">
  <em class="fa fa-home icon-breadcrumb"></em>
  <span class="text-breadcrumb">Início</span>
</div>

<div class="container-fluid">
  <div class="row" *ngIf="isVisible()">
    <div class="col-xl-3 col-md-6 mb-4">
      <div class="card border-left-primary shadow h-80 py-2">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <div class="col mr-2">
              <div class="text-xs fw-bold text-primary text-uppercase mb-1">Atendimentos</div>
              <div class="h5 mb-0 fw-bold text-gray-800" [countUp]="qtdeAtendimentos" [options]="configCounter">0</div>
            </div>
            <div class="col-auto">
              <i class="fa fa-hospital-o fa-2x text-gray-300"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-md-6 mb-4">
      <div class="card border-left-success shadow h-80 py-2">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <div class="col mr-2">
              <div class="text-xs fw-bold text-success text-uppercase mb-1">Procedimentos</div>
              <div class="h5 mb-0 fw-bold text-gray-800" [countUp]="qtdeProcedimentos" [options]="configCounter">0</div>
            </div>
            <div class="col-auto">
              <i class="fa fa-calendar fa-2x text-gray-300"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-md-6 mb-4">
      <div class="card border-left-info shadow h-80 py-2">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <div class="col mr-2">
              <div class="text-xs fw-bold text-info text-uppercase mb-1">Prestadores</div>
              <div class="h5 mb-0 fw-bold text-gray-800" [countUp]="qtdePrestadores" [options]="configCounter">0</div>
            </div>
            <div class="col-auto">
              <i class="fa fa-address-card fa-2x text-gray-300"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-md-6 mb-4">
      <div class="card border-left-warning shadow h-80 py-2">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <div class="col mr-2">
              <div class="text-xs fw-bold text-warning text-uppercase mb-1">Usuários</div>
              <div class="h5 mb-0 fw-bold text-gray-800" [countUp]="qtdeUsuarios" [options]="configCounter">0</div>
            </div>
            <div class="col-auto">
              <i class="fa fa-users fa-2x text-gray-300"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div style="text-align:center">
    <div class="row">
      <div class="col-md-12 col-lg-8 mb-4">
        <app-card titleCard="Atendimentos Mensais">
          <app-chart [data]="chartDataMes"></app-chart>
        </app-card>
      </div>
      <div class="col-md-12 col-lg-4 mb-4">
        <app-card titleCard="Atendimentos Anuais">
          <app-chart [data]="chartDataAno"></app-chart>
        </app-card>
      </div>
    </div>
  </div>
</div>
